import React, { useState, useRef } from 'react';
import { findDOMNode } from 'react-dom';
import { isNil, size } from 'lodash';
import Lightbox from 'react-18-image-lightbox';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';

import ConfirmationDialog from './ConfirmationDialog';

function PlusIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          d="M14.0002 4.30254V23.6975"
          stroke="#374649"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M4.30273 14H23.6977" stroke="#374649" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

function RenderImageLoader({ images, label, subLabel, readOnly, photoIndex, setPhotoIndex, name, onRemove, onLoad }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isDisplayRemoveImageConfirmationDialog, setIsDisplayRemoveImageConfirmationDialog] = useState(false);

  const fileUpload = useRef(null);

  const openFileDialog = () => {
    const fileUploadDom = findDOMNode(fileUpload.current);

    fileUploadDom.click();
  };

  const toggleDisplayRemoveImageConfirmationDialog = (e) => {
    e.stopPropagation();
    setIsDisplayRemoveImageConfirmationDialog(!isDisplayRemoveImageConfirmationDialog);
  };

  const handleRemove = () => {
    setIsDisplayRemoveImageConfirmationDialog(false);
    onRemove(images[photoIndex]);
  };

  const onClickItem = (activeIndex) => {
    setPhotoIndex(activeIndex);
    setIsOpen(true);
  };

  const onChange = (activeIndex) => {
    if (!isNil(activeIndex)) {
      setPhotoIndex(activeIndex);
    }
  };

  const handleImageChange = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    reader.onloadend = () => {
      onLoad(file, reader.result);
    };

    reader.readAsDataURL(file);
  };

  const imageUrls = images.map((image) => image.url);

  const imageRemoveBtn = !readOnly && size(images) > 0 && (
    <IconButton size="large" onClick={toggleDisplayRemoveImageConfirmationDialog} className="carousel-icon">
      <Delete />
    </IconButton>
  );

  const imageAddButton = !readOnly && (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <IconButton size="large" className="carousel-icon" onClick={openFileDialog}>
      <PlusIcon />
    </IconButton>
  );

  return (
    <div data-field-name={`${name}`} className="contents">
      {isOpen && (
        <Lightbox
          mainSrc={imageUrls[photoIndex]}
          nextSrc={imageUrls[(photoIndex + 1) % imageUrls.length]}
          prevSrc={imageUrls[(photoIndex + imageUrls.length - 1) % imageUrls.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + imageUrls.length - 1) % imageUrls.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % imageUrls.length)}
        />
      )}
      <div className="staticField cursor-auto">
        <div className="label corousel-component">
          {label}
          {subLabel && <span className="subLabel">{subLabel}</span>}
          <div>
            <input
              ref={fileUpload}
              type="file"
              accept="image/png, image/bmp, image/jpeg, image/gif"
              className="image-upload-button"
              onChange={handleImageChange}
              onClick={(e) => {
                e.target.value = null;

                return false;
              }} // allows to choose same file
            />

            <div className="carousel-images">
              {size(imageUrls) > 0 &&
                imageUrls.map((src, i) => (
                  <div
                    key={i}
                    className={`carousel-image${photoIndex === i ? ' selected' : ''}`}
                    onClick={() => setPhotoIndex(i)}
                  >
                    <img alt="" src={src} />
                  </div>
                ))}
              {imageAddButton}
            </div>

            {size(imageUrls) > 0 && imageUrls[photoIndex] && (
              <div className="image-preview" onClick={() => onClickItem(photoIndex)}>
                <img alt="" src={imageUrls[photoIndex]} />
                {imageRemoveBtn}
              </div>
            )}
          </div>
        </div>
      </div>
      <ConfirmationDialog
        onSubmit={handleRemove}
        onCancel={toggleDisplayRemoveImageConfirmationDialog}
        submitLabel="Remove"
        cancelLabel="Cancel"
        open={isDisplayRemoveImageConfirmationDialog}
        bodyText="Are you sure you want to remove this image?"
      />
    </div>
  );
}

export default RenderImageLoader;
